import Text from '@atoms/Text/Text';
import { IRelatedProducts } from '@models/IRelatedProducts';
import AddToMyListButton from '@molecules/AddToMyListButton/AddToMyListButton';
import ProductTile from '@organisms/ProductTile/ProductTile';
import { WishlistButtonContext } from '@utility/context/WishlistButtonContext';
import classNames from 'classnames';

const RelatedProducts = ({ heading, productCards }: IRelatedProducts) => (
  <WishlistButtonContext value={AddToMyListButton}>
    <section
      className={classNames(
        'tw-mb-16 tw-w-full md:tw-mb-20',
        heading && 'tw-border-t tw-border-grey-20 tw-pt-4',
      )}
    >
      <div className="b2b-container">
        {heading && (
          <Text as="h2" variant="ds-headline-2" className="tw-mb-8 md:tw-mb-10">
            {heading}
          </Text>
        )}
        <div className="tw-grid tw-grid-cols-4 tw-gap-8">
          {productCards.map((product) => (
            <div
              key={product.id}
              className="tw-col-span-4 md:tw-col-span-2 lg:tw-col-span-1"
            >
              <ProductTile {...product} />
            </div>
          ))}
        </div>
      </div>
    </section>
  </WishlistButtonContext>
);

export default RelatedProducts;
